import { getSyncBoxStateFromNodeId } from "src/lib/sync-box/utils";
// Function to check if the corresponding syncBox has synced at least once
export default async function isSyncBoxSynced(tableName, nodeId) {
    try {
        const syncBoxState = await getSyncBoxStateFromNodeId(tableName, nodeId);
        if (!syncBoxState)
            return false;
        const lastSyncedInfo = await syncBoxState.getLastSyncedInfo();
        // Check if lastSyncedAt exists and is greater than 0
        return (lastSyncedInfo.lastSyncedAt ?? 0) > 0;
    }
    catch (error) {
        // If any error occurs during the check, assume not synced
        console.warn('Error checking syncBox synced status:', error);
        return false;
    }
}
